const CHANGE_BOOKING_FORM_DATA = 'CHANGE_BOOKING_FORM_DATA'
const CLEAR_BOOKING_FORM_DATA = 'CLEAR_BOOKING_FORM_DATA'

export { CHANGE_BOOKING_FORM_DATA, CLEAR_BOOKING_FORM_DATA }
